module.exports = __webpack_public_path__ + "img/title_txt_day3.fd99a9e5.png";